"use strict";

module.exports = function getModificationsByRef(ref, target) {
	
	if((ref === undefined) || (target === undefined)) {
		return target;
	}
	
	if(((ref === null) && (target !== null)) ||
		((ref !== null) && (target === null))) {
		return target;
	}
	
	if((ref === null) && (target === null)) {
		return undefined;
	}
	
	if(ref.constructor != target.constructor) {
		return target;
	}
	
	let mod = undefined;
	
	if(ref.constructor === Object) {
		
		for(const key in target) {
			
			const nestedMod = getModificationsByRef(ref[key], target[key]);
			
			if(nestedMod !== undefined) {
				if(mod == undefined) {
					mod = {};
				}
				
				mod[key] = nestedMod;
			}
		}
		
	} else if(ref.constructor === Array) {
		
		if(ref.length != target.length) {
		
			mod = target;
		
		} else {
			
			const arrayModified = ref.some(function(refValue, ix) {
				return (getModificationsByRef(refValue, target[ix]) != undefined);
			});
		
			if(arrayModified) {
				mod = target;
			}
		}
		
	} else if (ref.constructor === Function) {
		
		// függvények esetén nem vizsgálódunk
		
	} else {
		
		if(ref !== target) {
			mod = target;
		}
	}
	
	return mod;
};



// WEBPACK FOOTER //
// ./~/vfu/getModificationsByRef.js